export enum Design {
  DESIGN_1 = 'design-1',
  DESIGN_2 = 'design-2',
}